var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"6","align-self":"center"}},[_c('v-card',[_c('v-card-title',[_vm._v(" Income Statements ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }